<template>
    <div class="base-bg" v-if="visible">
        <TopBar
                :title="$t('edit.editActionTitles.senceMaskSets')"
                @onClickClose="close"
                @onClickSave="saveMask"
                :right-btn="userInfo.level > 0 || userInfo.team_id > 0"
        ></TopBar>
        <global-single>
            <template v-slot:global>
                <MediaSelect
                        :url="form.fix_logo.land"
                        :title="$t('edit.settings.fixMap')"
                        :btnTitle="$t('actionTitles.changeCover')"
                        :isEdit="userInfo.level > 0 || userInfo.team_id > 0"
                        @changeMedia="updateGlobalLand"
                        @deleteMedia="deleteGlobalLand"
                        size="200 x 200"
                ></MediaSelect>
                <MediaSelect
                        :url="form.fix_logo.sky"
                        :title="$t('edit.settings.fixSky')"
                        :btnTitle="$t('actionTitles.changeCover')"
                        :isEdit="userInfo.level > 0 || userInfo.team_id > 0"
                        @changeMedia="updateGlobalSky"
                        @deleteMedia="deleteGlobalSky"
                        size="200 x 200"
                ></MediaSelect>
            </template>
            <template v-slot:single>
                <div class="sence-list">
                    <div class="list-item" v-for="(item,index) in senceList" :key="index">
                        <img :src="item.thumb_path"/>
                        <span class="titles">{{item.scene_title}}</span>
                        <a-button v-if="userInfo.level > 0 || userInfo.team_id > 0" type="primary" shape="round" @click="openSetMask(index)">{{$t('edit.setting')}}{{$t('edit.mask')}}</a-button>
                        <span class="tips" v-else>{{$t('edit.editMessage.defaultMask')}}</span>
                    </div>
                </div>
            </template>
        </global-single>
        <a-modal
                :title="curMaskSenceId!=''?senceList[curMaskSenceId].scene_title:''"
                :visible="maskVisible"
                @ok="maskVisible = false"
                @cancel="closeSetMask"
                :destroyOnClose="true"
                centered
                class="mask-modal"
        >
            <MediaSelect
                    :url="curMaskSenceId!='' && senceList[curMaskSenceId].sky_land_shade.land?senceList[curMaskSenceId].sky_land_shade.land:''"
                    :title="$t('edit.settings.fixMap')"
                    :btnTitle="$t('actionTitles.changeCover')"
                    @changeMedia="updateSingleLand"
                    @deleteMedia="deleteSingleLand"
                    size="200 x 200"
            ></MediaSelect>
            <MediaSelect
                    :url="curMaskSenceId!='' && senceList[curMaskSenceId].sky_land_shade.sky?senceList[curMaskSenceId].sky_land_shade.sky:''"
                    :title="$t('edit.settings.fixSky')"
                    :btnTitle="$t('actionTitles.changeCover')"
                    @changeMedia="updateSingleSky"
                    @deleteMedia="deleteSingleSky"
                    size="200 x 200"
            ></MediaSelect>
        </a-modal>
    </div>
</template>

<script>
    import TopBar from "./TopBar.vue";
    import MediaSelect from "./MediaSelect.vue";
    import {mapGetters} from "vuex";
    import GlobalSingle from "./GlobalSingle";

    export default {
        name: "MaskView",
        components: {
            TopBar,
            MediaSelect,
            GlobalSingle
        },
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                form: {
                    fix_logo: {
                        land: '',
                        sky: ''
                    }
                },
                senceList: [],
                curMaskSenceId: '',
                curMaskSenceTitle: '',
                maskVisible: false,
                curMaskList:{
                    sky_land_shade:{
                        land:'',
                        sky:''
                    }
                }
            };
        },
        computed: {...mapGetters(["vrbase",'userInfo'])},
        created() {
            this.form = this.$deepClone(this.vrbase.ads);
            this.senceList = this.$deepClone(this.vrbase.scenes)
        },
        methods: {
            close() {
                this.$emit("close");
            },
            updateGlobalLand(data) {
                this.form.fix_logo.land = data.url
            },
            deleteGlobalLand() {
                this.form.fix_logo.land = ''
            },
            updateGlobalSky(data) {
                this.form.fix_logo.sky = data.url
            },
            deleteGlobalSky() {
                this.form.fix_logo.sky = ''
            },
            openSetMask(index){
                this.curMaskSenceId = index
                this.maskVisible = true
            },
            closeSetMask(){
                this.maskVisible = false
                setTimeout(()=>{
                    this.senceList[this.curMaskSenceId] = this.$deepClone(this.vrbase.scenes)[this.curMaskSenceId]
                    this.curMaskSenceId = ''
                },200)

            },
            updateSingleLand(data){
                this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "land", data.url)
            },
            deleteSingleLand(){
                this.senceList[this.curMaskSenceId].sky_land_shade.land = ''
            },
            updateSingleSky(data){
                this.$set(this.senceList[this.curMaskSenceId].sky_land_shade, "sky", data.url)
            },
            deleteSingleSky(){
                this.senceList[this.curMaskSenceId].sky_land_shade.sky = ''
            },
            saveMask(){
                //const vrbase = { ...this.vrbase, ads: this.form,scenes: this.senceList };
                const vrbase = { ...this.vrbase, ads: this.form };
                for(let idx in vrbase.scenes){
                    if(this.senceList[idx].sky_land_shade){
                        vrbase.scenes[idx].sky_land_shade = this.senceList[idx].sky_land_shade
                    }
                }
                this.$store
                    .dispatch(
                        "saveVRBase",
                        {
                            vrbase,
                            showLoading: true,
                        },
                        true
                    )
                    .then(() => {
                        this.close()
                    });
            }
        },
    }
</script>

<style lang="less" scoped>
    .sence-list {
        .list-item {
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #555555;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:last-child {
                margin-bottom: 0;
                border-bottom: 0;
            }

            img {
                width: 30px;
                height: 30px;
                flex-shrink: 0;
            }

            span.titles {
                font-size: 12px;
                color: #ffffff;
                flex: 1;
                margin: 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            span.tips{
                font-size: 12px;
                color: #999;
                flex-shrink: 0;
                margin-left: 10px;
            }

            /deep/ .ant-btn {
                font-size: 12px;
                flex-shrink: 0;
                padding: 0 10px;
                height: 30px;
            }
        }
    }
    .mask-modal{
        /deep/ .tips{
            color: #999 !important;
        }
    }
</style>

